<template>
  <footer>
    <div @click="$router.push('/')" style="cursor:pointer;">
      <img :src="require('@/assets/foclarity-logo-white-sm.png')" alt="Foclarity" width="200" />
    </div>
    <div class="links">
      <div class="flink"><router-link to="/" v-show="false">Home</router-link></div>
      <div class="flink"><router-link to="/about" v-show="false">About</router-link></div>
      <div class="flink"><router-link to="/services" v-show="false">Services</router-link></div>
      <div class="flink"><router-link to="/partners" v-show="false">Partners</router-link></div>
    </div>
    <div class="links">
      <div class="flink">
        <a href="https://x.com/Foclarity" target="_blank" rel="noreferrer" >
          <img class="social-icon" src="@/assets/x-logo-black.png" alt="@Foclarity" title="Follow us on X" />
        </a>
      </div>
      <div class="flink">
        <a href="https://discord.gg/ndkD2dmAvS" target="_blank" rel="noreferrer" >
          <img class="social-icon" src="@/assets/ic_discord.svg" alt="Foclarity Discord" title="Join our Discord community" />
        </a>
      </div>
      <div class="flink">
        <a href="https://linkedin.com/company/Foclarity" target="_blank" rel="noreferrer" >
          <img class="social-icon" src="@/assets/ic_linkedin_52.png" alt="Foclarity LinkedIN" title="Follow us on LinkedIn" />
        </a>
      </div>
      <div class="flink">
        <a href="https://www.youtube.com/channel/UCgNpF3KSGVQdTqx-RwBxBqw" target="_blank" rel="noreferrer">
          <img class="social-icon" src="@/assets/yt_logo_mono_light.png" alt="Foclarity YouTube Channel" title="Subscribe to our YouTube channel" />
        </a>
      </div>
      <div class="flink">
        <a href="https://foclarity.substack.com/" target="_blank" rel="noreferrer">
          <img class="social-icon" src="@/assets/Substack-Icon-Branding.png" alt="Newsletter on Substack" title="Subscribe to our newsletter" />
        </a>
      </div>
    </div>

    <div class="links">
      <div class="flink"><router-link to="/login">Login</router-link></div>
      <div class="flink"><router-link :to="{ name: 'register', params: { r: 'r8jw934uHJnr' }}">Register</router-link></div>
      <div class="flink"><router-link to="/privacy">Privacy</router-link></div>
      <div class="flink"><router-link to="/contact">Contact</router-link></div>
    </div>
    <div class="links">
      <div class="flink">Copyright &copy;2025 Foclarity AI - a division of Custany, LLC</div>
    </div>
    <div class="links">
      <div>{{ lastlogin }}</div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      sociallinks: "Facebook Twitter LinkedIn",
      lastlogin: ''
    }
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
footer {
  margin: 0;
  padding: 30px 30px;
  text-align: right;
  @media only screen and (max-width: 600px) {
    text-align: center;
    padding: 30px 0px;
  }
  // background: #eee;
  // background: #81819e;
  background: linear-gradient(#07061e59, #07061e00 33%), radial-gradient(circle at -30% -50%, #0a0828 58%, #2e1973 68%, #582ecc 83%, #a081f5 98%, #b197f5 103%);
  z-index: 10000;
  & .links {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: .75rem;
    justify-content: right ;
    & .flink {
      padding: 10px ;
      display: flex;
      flex-direction: table;
      flex-basis: 100%;
      flex: 0 1 auto ;
      color: #ccc;
      & a {
        color: #ccc ;
        text-decoration: none ;
        &:hover {
          text-decoration: underline ;
        }
      }
    }
    @media only screen and (max-width: 600px) {
      justify-content: center;
    }
  }
}
.social-icon {
  height: 20px ;
}
</style>
